import _ from 'lodash';

import {
    useContext
} from 'react';

import LandscapeContext from '../contexts/landscapeContext.js';
import UserContext from '../contexts/userContext.js';

export function useLandscape(landscapeId) {
    const user = useContext(UserContext);
    const landscape = _.find(user?.landscapes, ({id}) => id === landscapeId);
    return landscape;
}

export function useCompany(companyId) {
    const landscape = useContext(LandscapeContext);
    const company = _.find(landscape?.companies, ({id}) => id === companyId);
    return company;
}
